let committedKey: string | null = null
const listeners = new Set<() => void>()

/** Called by NavigationSetup once a location has actually rendered. */
export const setCommittedLocationKey = (key: string): void => {
  committedKey = key
  listeners.forEach((listener) => listener())
}

export const getCommittedLocationKey = (): string | null => committedKey

export const subscribeCommittedLocation = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
